import React, { createContext, useState, useEffect } from "react";
import {
	CognitoUser,
	AuthenticationDetails,
	CognitoUserAttribute,
} from "amazon-cognito-identity-js";

import Pool from "../UserPool";

const AccountContext = createContext({} as any);

const Account = (props: any) => {
	const [isAuthenticated, setIsAuthenticated] = useState(false);

	useEffect(() => {
		const user = Pool.getCurrentUser();
		if (user) {
			setIsAuthenticated(true);
		} else {
			setIsAuthenticated(false);
		}
	}, []);

	const getSession = async () => {
		return await new Promise((resolve, reject) => {
			const user = Pool.getCurrentUser();
			if (user) {
				user.getSession((err: any, session: any) => {
					if (err) {
						reject();
					} else {
						resolve(session);
					}
				});
			} else {
				reject();
			}
		});
	};

	const Auth = async (Username: string, Password: string) => {
		return await new Promise((resolve, reject) => {
			const user = new CognitoUser({
				Username,
				Pool,
			});

			const authDetails = new AuthenticationDetails({
				Username,
				Password,
			});

			user.authenticateUser(authDetails, {
				onSuccess: (data) => {
					console.log("onSuccess: ", data);
					setIsAuthenticated(true);
					resolve(data);
				},
				onFailure: (err) => {
					console.error("onFailure: ", err);
					reject(err);
				},
				newPasswordRequired: (data) => {
					console.log("newPasswordRequired: ", data);
					resolve(data);
				},
			});
		});
	};

	const SignUp = async (
		Username: string,
		Password: string,
		Email: string
	) => {
		return await new Promise((resolve, reject) => {
			const emailAttribute = new CognitoUserAttribute({
				Name: "email",
				Value: Email,
			});

			Pool.signUp(
				Username,
				Password,
				[emailAttribute],
				[],
				(err, result: undefined | any) => {
					if (err) {
						console.log("Bad signup")
						console.log(err.message || JSON.stringify(err));
						reject(err);
					}
					let cognitoUser = result.user;
					console.log("user name is " + cognitoUser.getUsername());
					resolve(result)
				}
			);
		});
	};

	const VerifyUser = async (Username: string, ValidationData: string) => {
		return await new Promise((resolve, reject) => {
			const user = new CognitoUser({
				Username,
				Pool,
			});

			user.confirmRegistration(ValidationData, true, (err, result) => {
				if (err) {
					reject(err);
				} else {
					resolve(result);
				}
			});
		});
	};

	const UserForgotPassword = async (Username: string) => {
		return await new Promise((resolve, reject) => {
			const user = new CognitoUser({
				Username,
				Pool,
			});

			console.log(Username);

			user.forgotPassword({
				onSuccess: (data) => {
					console.log("onSuccess: ", data);
					resolve(data);
				},
				onFailure: (err) => {
					console.error("onFailure: ", err);
					reject(err);
				},
			});
		});
	};

	const ConfirmPassword = async (
		Username: string,
		VerificationCode: any,
		NewPassword: string
	) => {
		return await new Promise((resolve, reject) => {
			const user = new CognitoUser({
				Username,
				Pool,
			});

			user.confirmPassword(VerificationCode, NewPassword, {
				onSuccess: (data) => {
					console.log("onSuccess: ", data);
					console.log("New Password Confirmed");
					resolve(data);
				},
				onFailure: (err) => {
					console.error("onFailure: ", err);
					console.log("Cannot Confirm New Password");
					reject(err);
				},
			});
		});
	};

	const logout = () => {
		const user = Pool.getCurrentUser();
		if (user) {
			setIsAuthenticated(false);
			user.signOut();
		}
	};

	return (
		<AccountContext.Provider
			value={{
				Auth,
				VerifyUser,
				getSession,
				logout,
				isAuthenticated,
				UserForgotPassword,
				ConfirmPassword,
				SignUp
			}}
		>
			{props.children}
		</AccountContext.Provider>
	);
};

export { Account, AccountContext };
